import React from "react";
import colors, { colorsV2 } from "../../styles/colors";

import IconClose from "material-ui/svg-icons/navigation/close";

const style = {
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    flex: 1,
  },
  stepDetails: {
    fontFamily: "Poppins-Regular",
    color: colorsV2.primary,
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
    flex: 1,
  },
  body: {
    backgroundColor: "white",
    margin: 0,
    padding: 20,
    borderRadius: 15,
    maxWidth: "500px",
  },
  footer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignContent: "center",
    flex: 1,
    padding: 20,
  },
  buttonRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignContent: "center",
    flex: 1,
    padding: 20,
  },
  passiveButton: {
    fontFamily: "Poppins-Regular",
    color: colors.darkGrey,
    marginLeft: 20,
    fontSize: 18,
    fontWeight: "bold",
    textDecoration: "underline",
    cursor: "pointer",
  },
  actionButton: {
    fontFamily: "Poppins-Regular",
    color: colorsV2.lightningYellow,
    marginLeft: 20,
    fontSize: 18,
    fontWeight: "bold",
    textDecoration: "underline",
    cursor: "pointer",
  },
  help: {
    width: 120,
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    justifyContent: "center",
  },
  helpButton: {
    fontFamily: "Poppins-Regular",
    color: colors.darkGrey,
    fontSize: 18,
    fontWeight: "bold",
    textDecoration: "none",
  },
  demo: {
    fontFamily: "Poppins-Regular",
    color: colorsV2.primary,
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
    flex: 1,
  },
  demoCTA: {
    color: colorsV2.lightningYellow,
  },
  close: {
    cursor: "pointer",
  },
};

const CustomTooltip = ({
  continuous,
  index,
  step,
  size,
  backProps,
  closeProps,
  primaryProps,
  tooltipProps,
}) => (
  <div {...tooltipProps} style={style.body}>
    <div style={style.header}>
      <span style={style.stepDetails}>
        Step {index + 1} of {size}
      </span>
      <IconClose {...closeProps} style={style.close} />
    </div>
    {step.title && <h1>{step.title}</h1>}
    <div>{step.content}</div>
    <div style={style.footer}>
      <div style={style.help}>
        <a href="https://ac-health.com/help/" style={style.helpButton}>
          Need Help?
        </a>
      </div>
      <div style={style.buttonRow}>
        {index > 0 && (
          <div style={style.passiveButton} {...backProps}>
            Back
          </div>
        )}
        {continuous && (
          <div style={style.actionButton} {...primaryProps}>
            {index + 1 !== size ? "Next" : "Close"}
          </div>
        )}
        {!continuous && (
          <div style={style.passiveButton} {...closeProps}>
            Close
          </div>
        )}
      </div>
    </div>
    <div style={style.demo}>
      Prefer a 15 minute demo?{" "}
      <a
        href="https://meetings.hubspot.com/ac-health/demo"
        style={style.demoCTA}
      >
        Schedule Now
      </a>
    </div>
  </div>
);

export default CustomTooltip;



// WEBPACK FOOTER //
// ./src/components/guide/CustomTooltip.js